<span [class.opacity]="globalService.isLoader"><router-outlet></router-outlet></span>
<app-loader *ngIf="globalService.isLoader"></app-loader>
